import BaseInput from "./BasePhoneInput";
export default BaseInput;
